export default __webpack_public_path__ + "static/finindcase2-5181c3edd368e270192fbb45b8cc818e.png";